// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal-grid{display:grid;grid-column-gap:2rem;-webkit-column-gap:2rem;-moz-column-gap:2rem;column-gap:2rem;margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem;grid-template-columns:11.4% 11.7% 12.2% 16.5% 5% 7.9% 10.5% 9.7% 1.2%}", ""]);
// Exports
module.exports = exports;
